import type { AxiosError } from 'axios'
import axios from 'axios'
import { useCheckServerStatus } from '@/composables/use-check-server-status'
import { useGlobalMessage } from '@/composables/use-global-message'
import i18n from '@/locales'
import { LocaleToApi, RtnCode } from '~library/enums'
import {
  getBaseUrl,
  type ApiRequestHeaders,
  type ApiResponse
} from '~library/services'

const axiosInstance = axios.create({
  baseURL: getBaseUrl()
})

axiosInstance.interceptors.request.use(
  (config) => {
    const headers: ApiRequestHeaders = config.headers as ApiRequestHeaders

    headers.lang = LocaleToApi[i18n.global.locale.value]

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    if (
      response.data.rtnCode !== RtnCode.CODE_SUCCESS &&
      response.data.message
    ) {
      useGlobalMessage().showApiErrorMessage(response)
    }
    return response
  },
  async (error: AxiosError) => {
    const { checkServerStatus } = useCheckServerStatus()
    if (!(await checkServerStatus(error))) {
      return
    }

    if (error.response) {
      useGlobalMessage().showApiErrorMessage(error.response as ApiResponse)
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
